import React, { useEffect, useState } from "react";

import styles from "@/common/SizeDropdown/SizeDropdown.module.scss";
import Dropdown from "@/common/Dropdown";
import SizeGuidePopUp from "../SizeGuidePopUp";
import { useSelector } from "react-redux";
import { getCookie } from "cookies-next";
import { sortSizes } from "@/helpers/pdpHelpers";
import { generalConstants } from "@/utils/constants";

export default function SizeDropdown({
  sizeVariants,
  selectedSize,
  setSelectedSize,
  stickyProductBox,
  showStickyDropdown,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  sizeGuideType,
  productId,
  showLastOne
}) {
  const [isOneSize, setOneSize] = useState(false);
  let sizeData = [];
  let disabled = [];
  let fastShippingVariants = [];
  let dropdownTitle = selectedSize ? "Selected size : " : "Select your size";
  let singleQuantity = [];
  const [singleOneSize, setSingleOneSize] = useState(false); // state for one size - 1 variant left
  for (const size in sizeVariants) {
    if (sizeVariants.hasOwnProperty(size)) {
      if(parseInt(sizeVariants[size].priceV2.amount)!=0)
      {
        sizeData.push(size); 
      }
      if (!sizeVariants[size].availableForSale) disabled.push(size);

      if (sizeVariants[size].quantityAvailable === generalConstants.min_variant_quantity ) {
        singleQuantity.push(size);
      }
      // variant is fast shipping when value of local item is "Local"
      if (sizeVariants[size].local_item && sizeVariants[size].local_item.value === "Local") {
        fastShippingVariants.push(size);
      }
    }
  }
  sortSizes(sizeData);
  const handleDropdownToggle = (e) => {
    setIsSizeDropdownOpen(e);
  };

  const handleOutsideClick = () => {
    setIsSizeDropdownOpen(false);
  };

  const [loading, setLoading] = useState(false);

  const isWishlistLoading = useSelector(
    (state) => state.wishlist.loading_status
  );
  useEffect(() => {
    if (typeof sizeData[0] != "undefined" && sizeData[0].toLowerCase() == generalConstants.one_size) {
      setOneSize(true);
    } else {
      setOneSize(false);
    }
    if (sizeVariants["One Size"]?.quantityAvailable === 1) {
      setSingleOneSize(true);
    }
  },[]);

  useEffect(() => {
    if (isWishlistLoading) {
      if (getCookie("isFavourite")) {
        setLoading(true);
      }
    } else {
      setLoading(false);
    }
  }, [isWishlistLoading]);

  return (
    <>
      {isOneSize && (
        <div
          className={`typography-wrap ${
            typeof showStickyDropdown != "undefined" && !showStickyDropdown
              ? "d-none"
              : ""
          }`}
        >
          <div className={`custom-dropdown`}>
            <div className={`dropdown-lable ${styles.disabled} onesize`}>One Size
            {singleOneSize  && showLastOne && <span>1 left</span>}
            </div>
          </div>
        </div>
      )}
      {!isOneSize && (
        <Dropdown
          ArrowDown="images/Icons/Chevron/large.svg"
          data={sizeData}
          disabled={disabled}
          selected={selectedSize}
          setSelected={setSelectedSize}
          showStickyDropdown={showStickyDropdown}
          isDropdownOpen={isSizeDropdownOpen}
          parentHandleToggle={handleDropdownToggle}
          isDropup={false}
          handleOutsideClick={handleOutsideClick}
          dropdownTitle={dropdownTitle}
          loading={loading}
          sizeVariants={sizeVariants}
          productId={productId}
          singleQuantity={showLastOne?singleQuantity:""}
          fastShippingVariants={fastShippingVariants}
        />
      )}
      {stickyProductBox ||
        (sizeGuideType && (
          <div className={`d-none d-md-block ${styles.size_guide}`}>
            <SizeGuidePopUp sizeGuideType={sizeGuideType} className="xx-small-md xx-small-sm" tabIndex={0} pdp={true}/>
          </div>
        ))}
    </>
  );
}
